var r = /\s/;
function a(t) {
  for (var e = t.length; e-- && r.test(t.charAt(e)); )
    ;
  return e;
}
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_trimmedEndIndex.js
// module id = 1512
// module chunks = 41